import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0ec2ffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "share-icon" }, null, -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "banner-tc" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-tc-divider" }, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "rights" }
const _hoisted_9 = { class: "rights-title" }
const _hoisted_10 = { class: "rights-wrapper" }
const _hoisted_11 = { class: "rights-list" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "order" }
const _hoisted_15 = { class: "order-content" }
const _hoisted_16 = {
  key: 2,
  class: "submit"
}
const _hoisted_17 = {
  key: 3,
  class: "submit"
}

import { computed, onBeforeMount, reactive, ref, watch } from 'vue';
import { CommonTitle, MyButton, Tab, SortList } from './components';
import { TIcon } from '@tencent/web-vbui';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { CallErrorType, invoke, isCommonError, openSharePanel, ShareChannel, shareLink } from '@tencent/vb-app-bridge';
import { ShareResponse } from '@tencent/vb-app-bridge/lib/src/type/share';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { activateScroll, isFusionBankApp, limitScroll, to } from '@tencent/vb-web-base-core';
import Contract from '@tencent/vb-web-contract';
import { baseMixins } from '@common/mixins/baseMixins';
import { useRouter, useRoute } from 'vue-router';
import { GetRightHomeConfig } from '../../core/network/NodeAPI';
import { IOptionItemData, ITeslaRightHomeConfig } from '../../core/interface/IModel';
import { GetRightList } from '@common/core/network/activityAPI';
import { IRightItem, IRightSortConfig } from '@common/core/interface/IModel';
import { NOT_IN_TESLAWHITELIST, ProductInfoMap } from '@common/core/help/constant';
import { useGlobalState } from '../../store/carOwnerRight';
import { getUrlQuery } from '@common/utils/param';
import dayjs from 'dayjs';
import { useApply } from '@common/hooks/useApply';
import ApplyExtra from '@common/components/apply/applyExtra.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeslaOverview',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const { isActive = '0' } = route.query;
const from = getUrlQuery('from');
const state = useGlobalState();
const { getT } = i18n;
const $t = getT();
// i18n.setLang('en-GB');
const { setTitle, showModalError, isEng, getBaseParam } = baseMixins();
const isOutdate = computed(() => {
  if (state.value.date[0] && dayjs().isBefore(dayjs(state.value.date[0]))) {
    return true;
  }
  if (state.value.date[1] && dayjs().isAfter(dayjs(state.value.date[1]))) {
    return true;
  }
  return false;
});
setTitle($t('Tesla车主尊尚礼遇'));
// 活动首页配置
const configInfo = reactive<ITeslaRightHomeConfig>({
  bannerImg: '',
  rightTitle: [],
  infoImg1: '',
  infoTitle2: '',
  infolink1: '',
  activityImg1: '',
  activityLink1: '',
  activityImg2: '',
  activityLink2: '',
  link: '',
  keys: [],
});
const getConfigInfo = async () => {
  const [data, err] = await to(GetRightHomeConfig<ITeslaRightHomeConfig>({ brand: 'tesla' }));
  if (err) {
    showModalError(err.message, err.code);
    return;
  }
  configInfo.bannerImg = data.bannerImg;
  configInfo.rightTitle = data.rightTitle;
  configInfo.infoImg1 = data.infoImg1;
  configInfo.infoTitle2 = data.infoTitle2;
  configInfo.infolink1 = data.infolink1;
  configInfo.activityImg1 = data.activityImg1;
  configInfo.activityLink1 = data.activityLink1;
  configInfo.activityImg2 = data.activityImg2;
  configInfo.activityLink2 = data.activityLink2;
  configInfo.link = data.link;
  configInfo.keys = data.keys;
};

// 活动权益列表
let rightList: IRightItem[] = [];
const tabData = ref<IOptionItemData[]>([]);
const activeTabValue = ref('3');
const curSorts = ref<IRightSortConfig[]>([]);
const getRightList = async () => {
  if (state.value.allTeslaRightList?.length) {
    rightList = state.value.allTeslaRightList;
  } else {
    const [data, err] = await to(GetRightList('tesla'));
    if (err) {
      showModalError(err.message, err.code);
      return;
    }
    state.value.allTeslaRightList = data;
    rightList = data;
  }
  setCurRights();
  tabData.value = rightList.map((item) => {
    const obj: IOptionItemData = {};
    obj.value = item.rankIndex;
    obj.label = item.rank.replace(' ', '\n\r');
    return obj;
  });
};

const setCurRights = () => {
  const rightItem = rightList.find((item) => item.rankIndex === activeTabValue.value);
  if (rightItem) {
    curSorts.value = rightItem.sorts;
  }
};

watch(activeTabValue, () => {
  reportStatistics({
    evtName: `rightRank${activeTabValue.value}BtnClick`,
    desc: `tesla车主权益预览页面奖品等级${activeTabValue.value}按钮点击`,
  });
  setCurRights();
});

onBeforeMount(async () => {
  spin.show();
  await Promise.all([getConfigInfo(), getRightList()]);
  spin.hide();
});
const goOrderPage = () => {
  router.push('/teslaOrder');
};
const goMerchantInfoPage = () => {
  router.push('/rightMerchant');
};

const goActivityPage = (link: string) => {
  if (link) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    window.top!.location.href = link;
  }
};

// 查看协议
const checkProto = () => {
  const contract = new Contract({
    key: configInfo.keys[0],
    autoSign: false,
    containerType: 'dialog',
    needAgree: false,
    needCheckBox: false,
    needLogin: false,
    hideBtn: true,
    needTitle: false,
  });
  contract.preview();
};

// 分享活动
const handleShare = async () => {
  reportStatistics({
    evtName: 'linkShare',
    desc: '特斯拉权益专区页面分享按钮点击',
  });
  try {
    const channel = await openSharePanel([
      ShareChannel.FACEBOOK,
      ShareChannel.WECHAT_MESSAGE,
      ShareChannel.WECHAT_MOMENT,
      ShareChannel.MESSENGER,
      ShareChannel.MORE,
    ]);
    if (channel === ShareChannel.UNKNOWN) {
      // 需要处理未知的渠道
      return;
    }
    /* eslint-disable */
    const result = await shareLink(channel, {
      thumbPath: require('@/assets/images/carOwnerRight/share-tesla.png'),
      title: `☀️${$t('齐齐享富融Tesla绿色夏日车主赏！')}`,
      link: 'https://www.fusionbank.com/tesla.html?lang=sc',
      content: `✍️${$t('登记成为车主赚HKD100回赠，仲有优惠总值高达HKD10,000 车主礼遇添!')}💰`,
    });
    if (result.result === '0') {
      reportStatistics({
        evtName: 'linkShareSuccess',
        desc: '特斯拉权益专区页面分享成功',
      });
    }
  } catch (err) {
    if (isCommonError(err)) {
      if (err.type === CallErrorType.OTHER_ERROR) {
        const { msg, result } = err.result as ShareResponse;
        if (result !== '0') {
          reportStatistics({
            evtName: 'linkShareError',
            desc: '特斯拉权益专区页面分享失败',
          });
        }
        console.log(msg);
        // 0    分享成功
        // -1    分享失败
        // -2    分享渠道对应app没安装
        // -3    用户主动取消
        // -4    相册权限未经用户授权    涉及图片操作时需要该权限
      }
    }
  }
};

const stateApply = reactive({
  isChecked: false,
  indexText: '',
  limitChecked: false,
  menuActionSheet: false,
  seq: '',
});
const teslaRegisterData = reactive({ code: 0, fromTag: '' });

const prodNo = getBaseParam('prodNo') as string;
const residentType = getUrlQuery('residentType') as string;
const { submitApply } = useApply(prodNo);

const handleClickApply = async () => {
  reportStatistics({ evtName: 'loanApplyClick' });
  const code = await submitApply({
    residentType: Number(residentType),
  });
  if (code === NOT_IN_TESLAWHITELIST) {
    openSheet();
  }
};

function openSheet() {
  limitScroll();
  stateApply.menuActionSheet = true;
}

function closeSheet() {
  activateScroll();
  stateApply.menuActionSheet = false;
}

async function teslaCheckTypeClick(type: string) {
  closeSheet();
  const senceId = getUrlQuery('senceId') || '';
  if (type !== 'TESLAFAQ') {
    const rst = await invoke<{ code: number; fromTag: string }>(
      `https://www.fusionbank.com/h5/walletLoan/app/index.html?fromTag=${teslaRegisterData.fromTag}&checkType=${type}&prodNo=${prodNo}&activeTag=${prodNo}&senceId=${senceId}#/teslaIdentify`,
      {
        target: 'web',
      },
    );
    if (rst) {
      teslaRegisterData.code = rst.code;
      teslaRegisterData.fromTag = rst.fromTag;
    }

    if (rst && rst.code === 0) {
      handleClickApply();
    }
  } else {
    const queryString = new URLSearchParams(Object.entries(getUrlQuery())).toString();
    window.location.href = `https://www.fusionbank.com/h5/walletLoan/app/index.html?${queryString}#/teslaFaq`;
  }
}

// 预览合同
async function previewContract(key: string) {
  const contractObj = new Contract({
    key,
    autoSign: false,
    containerType: 'dialog',
    needAgree: false,
    needLogin: false,
    needBackBtn: !isFusionBankApp,
    needTitle: !isFusionBankApp,
    needCheckBox: false,
    hideBtn: true,
  });

  await contractObj.preview();
}

function updateMenuActionSheet(val: boolean) {
  stateApply.menuActionSheet = val;
}

// 立即激活权益
const handleClick = async () => {
  const senceId = getUrlQuery('senceId') || '';
  await reportStatistics({
    evtName: 'activeBtnClick',
    desc: 'tesla车主权益预览页面立即激活权益按钮点击',
  });
  // 有时跳转页面很慢，需要给个loading动画
  spin.show();
  setTimeout(() => {
    spin.hide();
  }, 3000);
  window.top!.location.href = `/h5/walletLoan/app/index.html?senceId=${senceId}&product_no=${ProductInfoMap.TESLA}&activeTag=${ProductInfoMap.TESLA}&from=teslaRight`;
};

return (_ctx: any,_cache: any) => {
  const _directive_stat = _resolveDirective("stat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "share",
        onClick: handleShare
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_unref($t)('分享')), 1)
      ]),
      _createElementVNode("img", {
        src: configInfo.bannerImg,
        alt: "",
        class: "logo"
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (previewContract('CreditLineKFS'))),
          class: "banner-tc-text"
        }, [
          _createTextVNode(_toDisplayString(_unref($t)('产品资料概要')), 1)
        ])), [
          [_directive_stat, { event: 'teslaCreditLineKFS', num: '1' }]
        ]),
        _hoisted_6,
        _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (previewContract('CreditLineTC'))),
          class: "banner-tc-text"
        }, [
          _createTextVNode(_toDisplayString(_unref($t)('条款及细则')), 1)
        ])), [
          [_directive_stat, { event: 'teslaCreditLineTC', num: '1' }]
        ])
      ])
    ]),
    (configInfo.activityImg1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "activity",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goActivityPage(configInfo.activityLink1)))
        }, [
          _createElementVNode("img", {
            src: configInfo.activityImg1,
            alt: ""
          }, null, 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(CommonTitle), {
          title: configInfo.rightTitle[0]
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_unref(Tab), {
          options: tabData.value,
          modelValue: activeTabValue.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTabValue).value = $event))
        }, null, 8, ["options", "modelValue"]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(SortList), { sorts: curSorts.value }, null, 8, ["sorts"])
        ])
      ])
    ]),
    (configInfo.activityImg2)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "activity",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (goActivityPage(configInfo.activityLink2)))
        }, [
          _createElementVNode("img", {
            src: configInfo.activityImg2,
            alt: ""
          }, null, 8, _hoisted_12)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "register",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (goActivityPage(configInfo.infolink1)))
    }, [
      _createElementVNode("img", {
        src: configInfo.infoImg1,
        alt: ""
      }, null, 8, _hoisted_13)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_unref(CommonTitle), {
        title: configInfo.infoTitle2
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", null, _toDisplayString(_unref($t)('Fusion Bank用户专享')), 1),
        _createElementVNode("div", {
          class: "link",
          onClick: goOrderPage
        }, [
          _createElementVNode("a", null, _toDisplayString(_unref($t)('预约方法')), 1),
          _createVNode(_unref(TIcon), {
            "icon-name": "more",
            theme: "link",
            size: "small"
          })
        ])
      ])
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["detail", { eng: _unref(isEng) }])
    }, [
      _createElementVNode("span", { onClick: checkProto }, _toDisplayString(configInfo.link), 1),
      _createElementVNode("span", { onClick: goMerchantInfoPage }, _toDisplayString(_unref($t)('查看礼遇合作商户信息')), 1)
    ], 2),
    (_unref(from) === 'limit')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_unref(MyButton), {
            text: _unref($t)('即时申请'),
            onClick: handleClickApply
          }, null, 8, ["text"])
        ]))
      : (_unref(from) !== 'rightMy' && !_unref(isOutdate) && _unref(isActive) === '0')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_unref(MyButton), {
              text: _unref($t)('立即激活礼遇'),
              onClick: handleClick
            }, null, 8, ["text"])
          ]))
        : _createCommentVNode("", true),
    _createVNode(ApplyExtra, {
      menuActionSheet: stateApply.menuActionSheet,
      "onUpdate:menuActionSheet": updateMenuActionSheet,
      onTeslaCheckTypeClick: teslaCheckTypeClick,
      onCloseSheet: closeSheet
    }, null, 8, ["menuActionSheet"])
  ]))
}
}

})